import React, { useState, useEffect } from "react";
import axios from "./../../utils/axiosInstance";
import { useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { RxExit } from "react-icons/rx";
import { loadStripe } from "@stripe/stripe-js";
import { Dialog } from "radix-ui";
import { RiQuillPenLine } from "react-icons/ri";

const Subscription = ({ profile }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentPlan, setCurrentPlan] = useState(
    searchParams.get("plan") || ""
  );
  const [planCounts, setPlanCounts] = useState({});
  const token = localStorage.getItem("token");

  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
  );

  // useEffect(() => {
  //   fetchPlanCounts();
  // }, []);

  // const fetchPlanCounts = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_BASED_URL}/payment/planCounts`
  //     );
  //     const counts = {};
  //     response.data.forEach((item) => {
  //       counts[item.plan] = item.count;
  //     });
  //     setPlanCounts(counts);
  //   } catch (error) {
  //     console.error("Error fetching plan counts:", error);
  //   }
  // };

  const handleUpgradePlan = async (newPlan) => {
    if (newPlan === currentPlan) return;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASED_URL}/payment/updatePlan`,
        { newPlan }
      );
      const stripe = await stripePromise;
      const { sessionId } = response.data;
      await stripe.redirectToCheckout({ sessionId });

      // if (response.status === 200) {
      //   toast.success(response.data.message);
      //   // Refresh plan counts and any other relevant data
      //   fetchPlanCounts();
      // }
      // setCurrentPlan(newPlan);
    } catch (error) {
      console.error("Error upgrading plan:", error);
      // toast.error(error.response.data.message);
    }
  };

  return (
    // <div className="flex min-h-screen pt-[100px] px-[40px]">
    //   <div className="min-w-full">
    //     <div className="flex flex-row gap-3 items-center justify-center">
    //       <p className="text-[#717F87] text-[20px] text-center leading-[27px] font-medium">
    //         Choose the plan that fits your needs and start AI Script Writer.
    //       </p>
    //       <button
    //         className="flex flex-row gap-1 items-center px-2 py-1 bg-blue-500 rounded-xl"
    //         onClick={() => {
    //           window.location.href = "/dashboard";
    //         }}
    //       >
    //         <p className="font-medium text-neutral-50 text-sm">Dashboard</p>
    //         <RxExit color="white" />
    //       </button>
    //     </div>

    //     <div className="mt-[30px] inline-flex border border-[#E1E3E5] shadow-[0px 1px 2px #E1E3E5] divide-[#E1E3E5] divide-x rounded-[5px]">
    //       <button className="bg-white hover:bg-[#F6F6F7] hover:text-[#717F87] text-[#0E1823] leading-[16px] text-[13px] font-medium py-[15px] px-[25px] rounded-l">
    //         Monthly
    //       </button>
    //       {/* <button className="bg-white hover:bg-[#F6F6F7] hover:text-[#717F87] text-[#0E1823] text-[13px] leading-[16px] font-semibold font-bold py-[15px] px-[25px] rounded-r">
    //                     Annual
    //                 </button> */}
    //     </div>

    //     <div className="mt-[20px] grid grid-cols-3 gap-[20px]">
    //       <div
    //         key="trial"
    //         className="w-full bg-[#fff] rounded-[10px] shadow-[0px 1px 2px #E1E3E5] border border-[#E1E3E5] divide-y"
    //       >
    //         <div className="pt-[15px] px-[25px] pb-[25px]">
    //           <div className="flex justify-end">
    //             <div className="bg-neutral-300 rounded-[20px] flex justify-center align-center px-[12px]">
    //               <p className="text-[#00153B] text-[20px] leading-[28px] font-bold">
    //                 Trial
    //               </p>
    //             </div>
    //           </div>

    //           <div>
    //             <p className="text-[#00153B] text-[50px] leading-[63px] font-bold">
    //               $1
    //             </p>
    //           </div>

    //           <div>
    //             <p className="text-[#717F87] text-[18px] leading-[28px] font-medium">
    //               50 Credits
    //             </p>
    //             <p className="text-[#717F87] text-[18px] leading-[28px] font-medium">
    //               Users: {planCounts.Trial || 0}
    //             </p>
    //           </div>
    //         </div>

    //         <div className="pt-[25px] px-[25px] pb-[35px]">
    //           <div></div>
    //           <div className="mt-[25px]">
    //             <button
    //               className={`${
    //                 currentPlan === "Trial"
    //                   ? "bg-neutral-300"
    //                   : "bg-neutral-300"
    //               } rounded-[5px] py-[15px] px-[25px] text-[#fff] text-[14px] leading-[17px] font-semibold`}
    //               onClick={() => handleUpgradePlan("Trial")}
    //             >
    //               {currentPlan === "Trial" ? "Current Plan" : "Not available"}
    //             </button>
    //           </div>
    //         </div>
    //       </div>

    //       <div
    //         key="basic"
    //         className="w-full bg-[#fff] rounded-[10px] shadow-[0px 1px 2px #E1E3E5] border border-[#E1E3E5] divide-y"
    //       >
    //         <div className="pt-[15px] px-[25px] pb-[25px]">
    //           <div className="flex justify-end">
    //             <div className="bg-neutral-300 rounded-[20px] flex justify-center align-center px-[12px]">
    //               <p className="text-[#00153B] text-[20px] leading-[28px] font-bold">
    //                 Basic
    //               </p>
    //             </div>
    //           </div>

    //           <div>
    //             <p className="text-[#00153B] text-[50px] leading-[63px] font-bold">
    //               $15
    //             </p>
    //           </div>

    //           <div>
    //             <p className="text-[#717F87] text-[18px] leading-[28px] font-medium">
    //               2000 Credits per month
    //             </p>
    //             <p className="text-[#717F87] text-[18px] leading-[28px] font-medium">
    //               Users: {planCounts.Basic || 0}
    //             </p>
    //           </div>
    //         </div>

    //         <div className="pt-[25px] px-[25px] pb-[35px]">
    //           <div></div>
    //           <div className="mt-[25px]">
    //             <button
    //               className={`${
    //                 currentPlan === "Basic" ? "bg-neutral-300" : "bg-[#006EF5]"
    //               } rounded-[5px] py-[15px] px-[25px] text-[#fff] text-[14px] leading-[17px] font-semibold`}
    //               onClick={() => handleUpgradePlan("Basic")}
    //             >
    //               {currentPlan === "Basic" ? "Current Plan" : "Switch to Basic"}
    //             </button>
    //           </div>
    //         </div>
    //       </div>

    //       <div
    //         key="pro"
    //         className="w-full bg-[#fff] rounded-[10px] shadow-[0px 1px 2px #E1E3E5] border border-[#E1E3E5] divide-y"
    //       >
    //         <div className="pt-[15px] px-[25px] pb-[25px]">
    //           <div className="flex justify-end">
    //             <div className="bg-neutral-300 rounded-[20px] flex justify-center align-center px-[12px]">
    //               <p className="text-[#00153B] text-[20px] leading-[28px] font-bold">
    //                 Pro
    //               </p>
    //             </div>
    //           </div>

    //           <div>
    //             <p className="text-[#00153B] text-[50px] leading-[63px] font-bold">
    //               $30
    //             </p>
    //           </div>

    //           <div>
    //             <p className="text-[#717F87] text-[18px] leading-[28px] font-medium">
    //               4500 Credits per month
    //             </p>
    //             <p className="text-[#717F87] text-[18px] leading-[28px] font-medium">
    //               Users: {planCounts.Pro || 0}
    //             </p>
    //           </div>
    //         </div>

    //         <div className="pt-[25px] px-[25px] pb-[35px]">
    //           <div></div>
    //           <div className="mt-[25px]">
    //             <button
    //               className={`${
    //                 currentPlan === "Pro" ? "bg-neutral-300" : "bg-[#006EF5]"
    //               } rounded-[5px] py-[15px] px-[25px] text-[#fff] text-[14px] leading-[17px] font-semibold`}
    //               onClick={() => handleUpgradePlan("Pro")}
    //             >
    //               {currentPlan === "Pro" ? "Current Plan" : "Switch to Pro"}
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <button
      className="flex h-[35px] items-center justify-center rounded-xl bg-violet4 px-[15px] font-medium leading-none text-green11 outline-none outline-offset-1 hover:bg-mauve3 focus-visible:outline-2 focus-visible:outline-violet6 select-none shadow-lg"
      onClick={() => {
        window.location.href =
          "https://leveraged-creator.thrivecart.com/scriptwrite/";
      }}
    >
      <div className="mr-2 pt-[1px]">
        <RiQuillPenLine color="green" />
      </div>
      <p>
        {Math.floor(profile.plan.creditsUsed)} / {profile.plan.maxCredits}
      </p>
    </button>
    // <Dialog.Root>
    //   <Dialog.Trigger asChild>
    //     <button className="flex h-[35px] items-center justify-center rounded-xl bg-violet4 px-[15px] font-medium leading-none text-green11 outline-none outline-offset-1 hover:bg-mauve3 focus-visible:outline-2 focus-visible:outline-violet6 select-none shadow-lg">
    //       <div className="mr-2 pt-[1px]">
    //         <RiQuillPenLine color="green" />
    //       </div>
    //       <p>
    //         {Math.floor(profile.plan.creditsUsed)} / {profile.plan.maxCredits}
    //       </p>
    //     </button>
    //   </Dialog.Trigger>
    //   <Dialog.Portal>
    //     <Dialog.Overlay className="fixed inset-0 bg-blackA6 backdrop-blur-md dark:bg-whiteA3 data-[state=open]:animate-overlayShow" />
    //     <Dialog.Content className="fixed h-[65vh] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-transparent p-[25px] shadow-[var(--shadow-6)] focus:outline-none data-[state=open]:animate-contentShow">
    //       <div className="flex items-center gap-12 h-full">
    //         <div className="flex flex-col items-center w-[22rem] h-full p-6 rounded-xl shadow-[0px_4px_8px_rgba(0,0,0,0.2)] bg-blackA6 dark:bg-whiteA6 backdrop-blur-sm text-white dark:text-gray-800">
    //           <h3 className="text-3xl font-bold mt-12">Basic Plan</h3>
    //           <p className="text-sm mt-2">
    //             Ideal for individuals starting out.
    //           </p>
    //           <div className="text-4xl font-bold mt-12">
    //             $59.9<small className="text-sm font-normal">/month</small>
    //           </div>
    //           <button
    //             className="mt-6 px-6 py-2 w-[80%] bg-indigo-500 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700"
    //             onClick={() => handleUpgradePlan("Basic")}
    //           >
    //             Choose Plan
    //           </button>
    //           <p className="mt-12">718.8$ billed per year.</p>
    //           <p className="mt-2">2k credits per month.</p>
    //         </div>
    //         <div className="flex flex-col items-center w-[20rem] h-[93%] p-6 rounded-xl shadow-[0px_4px_8px_rgba(0,0,0,0.2)] bg-blackA4 dark:bg-whiteA4 backdrop-blur-sm text-white dark:text-gray-800">
    //           <h3 className="text-3xl font-bold mt-12">Pro Plan</h3>
    //           <p className="text-sm mt-2">
    //             Ideal for professionals and small teams.
    //           </p>
    //           <div className="text-4xl font-bold mt-12">
    //             $119.9<small className="text-sm font-normal">/month</small>
    //           </div>
    //           <button
    //             className="mt-6 px-6 py-2 w-[80%] bg-indigo-500 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700"
    //             onClick={() => handleUpgradePlan("Pro")}
    //           >
    //             Choose Plan
    //           </button>
    //           <p className="mt-12">1438.8$ billed per year.</p>
    //           <p className="mt-2">4.5k credits per month.</p>
    //         </div>
    //       </div>
    //     </Dialog.Content>
    //   </Dialog.Portal>
    // </Dialog.Root>
  );
};

export default Subscription;
